export const grant = (_x: any, data: any) => {
  return [
    {
      __typename: "Grant",
      policies: ["General Manager", "Assistant Manager"]
    }
  ];
};
